import { Injectable } from '@angular/core';
import { ErrorMessageResponse } from '@app/core/models/data-response';
import { DataTaskService } from '@app/core/services/data-task.service';

@Injectable({
    providedIn: 'root',
})
export class RequisitionService {
    constructor(private datatask: DataTaskService) {}

    /**
     * @datatask 3505
     * @datataskName tt_requisitionsimplified_get
     * @returns promise containing page load for requsition simplified.
     */
    public async get(): Promise<RequisitionSimplifiedGet> {
        return (await this.datatask.Post(3505))[0];
    }

    /**
     * @datatask 3501
     * @datataskName tt_requisitionsimplified_stockplace_from_selectlist
     * @returns promise containing stockplace from options for requisition simplified.
     */
    public getStockplaceFrom(): Promise<RequisitionSimplifiedStockplaceFromItem[]> {
        return this.datatask.Post(3501);
    }

    /**
     * @datatask 3502
     * @datataskName tt_requisitionsimplified_stockplace_to_selectlist
     * @returns promise containing stockplace to options for requisition simplified.
     */
    public getStockplaceTo(): Promise<RequisitionSimplifiedStockplaceToItem[]> {
        return this.datatask.Post(3502);
    }

    /**
     * @datatask 3503
     * @datataskName tt_requisitionsimplified_labour_selectlist
     * @returns promise containing labour options for requisition simplified.
     */
    public getLabour(): Promise<RequisitionSimplifiedLabourItem[]> {
        return this.datatask.Post(3503);
    }

    /**
     * @datatask 3504
     * @datataskName tt_requisitionsimplified_status_selectlist
     * @returns promise containing status options for requisition simplified.
     */
    public getStatus(): Promise<RequisitionSimplifiedStatusItem[]> {
        return this.datatask.Post(3504);
    }

    /**
     * @datatask 3508
     * @datataskName tt_requisitionsimplified_send
     * @returns promise containing error code and message for the send operation.
     */
    public async send(params: RequisitionSimplifiedActionParams): Promise<ErrorMessageResponse> {
        return (await this.datatask.Post(3508, params))[0];
    }

    /**
     * @datatask 3509
     * @datataskName tt_requisitionsimplified_receive
     * @returns promise containing error code and message for the receive operation.
     */
    public async receive(params: RequisitionSimplifiedActionParams): Promise<ErrorMessageResponse> {
        return (await this.datatask.Post(3509, params))[0];
    }

    /**
     * @datatask 3510
     * @datataskName tt_requisitionsimplified_rollback_send
     * @returns promise containing error code and message for the undo send operation.
     */
    public async undoSend(params: RequisitionSimplifiedActionParams): Promise<ErrorMessageResponse> {
        return (await this.datatask.Post(3510, params))[0];
    }

    /**
     * @datatask 3511
     * @datataskName tt_requisitionsimplified_rollback_receive
     * @returns promise containing error code and message for the undo receive operation.
     */
    public async undoReceive(params: RequisitionSimplifiedActionParams): Promise<ErrorMessageResponse> {
        return (await this.datatask.Post(3511, params))[0];
    }
}

export interface RequisitionSimplifiedGet {
    requisitiondel_keyno: string;
    requisitiondel_keyno_from: string;
    stockplace_id_from: string;
    stockplace_id_to: string;
    labour_no: string;
    status_no: string;
    selected_requisitiondel_keyno: string | number | null;
    show_setting: '0' | '1';
}

export interface RequisitionSimplifiedStockplaceFromItem {
    stockplace_id_from: string;
    stockplace_name_from: string;
}

export interface RequisitionSimplifiedStockplaceToItem {
    stockplace_id_to: string;
    stockplace_name_to: string;
}

export interface RequisitionSimplifiedLabourItem {
    labour_no: string;
    labour_name: string;
}

export interface RequisitionSimplifiedStatusItem {
    requisitiondelstatus_id: string;
    requisitiondelstatus_name: string;
}

export interface RequisitionSimplifiedActionParams {
    requisitiondel_keyno: string | number;
}

export type RequisitionSimplifiedAction = 'send' | 'receive' | 'undo_send' | 'undo_receive';
